import styled from "styled-components";

import { theme } from "../../themes/themes";
export const ContentTable = styled.div`
  grid-column: 1/4;
  .MuiPaper-elevation2 {
    box-shadow: none;
  }
  .css-11bfvty-MuiToolbar-root-MuiTablePagination-toolbar {
    display: flex;
    align-items: baseline;
  }
  tr[level="0"]:nth-child(even) {
    background-color: ${({ theme }) => theme.neutral.gray[200]};
  }
  tr[level]:has(+ tr:not([level])) {
    background-color: #f7eaf7;
  }
  .MuiTableRow-root {
    height: 49px;
  }
  .MuiPaper-root .MuiToolbar-root {
    min-height: 25px;
  }
  .MuiTableCell-root {
    padding: 12px;
  }
  .MuiTableCell-alignLeft {
    text-align: center;
  }
`;

export const ContentTableSubPolicy = styled.div`
  margin: 20px 5%;
  width: 90%;
`;
